import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import ISONumber from "components/formatting/ISONumber";
import ISODateTime from "components/formatting/ISODateTime";
import TitleCase from "components/formatting/TitleCase";

interface SparklineTooltipProps {
  data: any;
  index: number | null;
}

export default function SparklineTooltip(props: SparklineTooltipProps): JSX.Element {
  const { i18n } = useTranslation();
  const { data, index }: SparklineTooltipProps = props;

  const dataPoint = data?.[index];
  const date = dataPoint?.date;

  if (!dataPoint) {
    return <></>;
  }
  
  // If the label is "Records" OR the label is the same as the subLabel, display the label. 
  // Otherwise, display the subLabel, which is more descriptive.
  const label = dataPoint?.label;
  let displayLabel = "";
  if (label === "Records" || label === dataPoint?.subLabel) {
    displayLabel = label;
  } else {
    displayLabel = dataPoint.subLabel;
  }

  // Since we have a few different formats for dates, we need to check if the date is a valid date
  // If it is, we will use the ISODateTime component to format it, otherwise, we will just display the date as is
  const testDate = new Date(date); 
  const validDate = testDate.getTime() > 0;

  return (
    <Box>
      {/* Title */}
      {validDate ? (
        <ISODateTime isoString={date} typographyVariant={"h4"}/> 
      ) : (
        <Typography sx={{ fontWeight: "bold" }}>
          {date}
        </Typography>
      )}

      {/* Value */}
      <Typography>
        <TitleCase text={displayLabel} />:
        <Box sx={{ display: "inline-block", ml: 1 }}>
          <ISONumber number={dataPoint?.value} sx={{ fontWeight: "bold" }}/>  
        </Box>
      </Typography>
    </Box>
  );
} 